var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "moment-wrapper" }, [
    _c("div", { staticClass: "moment-background" }),
    _vm._v(" "),
    _c("div", { staticClass: "moment", attrs: { "data-height": _vm.size } }, [
      _vm.loading
        ? _c("div", { staticClass: "moment-loader" }, [_vm._m(0)])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "moment-header" },
        [
          _c("div", { staticClass: "moment-header-favicon" }),
          _vm._v(" "),
          _c("div", { staticClass: "moment-header-title" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _vm._v(" "),
          _c("a-icon", {
            staticClass: "moment-close",
            attrs: { type: "close" },
            on: {
              click: function ($event) {
                return _vm.$emit("close")
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "moment-frame-wrapper", attrs: { "data-ios": "false" } },
        [
          _c("iframe", {
            attrs: {
              src: _vm.url,
              id: "main-content-iframe",
              sandbox:
                "allow-forms allow-pointer-lock allow-popups allow-popups-to-escape-sandbox allow-presentation allow-same-origin allow-scripts",
            },
            on: {
              load: function ($event) {
                _vm.loading = false
              },
            },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loader" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }